/**
 * Borrowed from https://github.com/agraboso/redux-api-middleware/blob/master/src/errors.js
 */

/**
 * Error class that works as a base for errors that contain stack traces.
 * It allows us to wrap an error, and keep the original error in the
 * cause property for debug,
 *
 * @class BaseError
 * @access public
 * @param {string}  messsage - the error message
 * @param {Error}   cause    - the original error
 */
export default class BaseError extends Error {
  cause: Error;

  constructor(message: string, cause: Error) {
    super();
    this.message = message;
    this.cause = cause;
  }
}
